function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
import { Vex } from './vex';
import { Flow } from './tables';
import { Element } from './element';
import { BoundingBoxComputation } from './boundingboxcomputation';
import { BoundingBox } from './boundingbox';

function processOutline(outline, originX, originY, scaleX, scaleY, outlineFns) {
  var command;
  var x;
  var y;
  var i = 0;

  function nextX() {
    return originX + outline[i++] * scaleX;
  }

  function nextY() {
    return originY + outline[i++] * scaleY;
  }

  function doOutline(command) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    outlineFns[command].apply(outlineFns, args);
  }

  while (i < outline.length) {
    command = outline[i++];

    switch (command) {
      case 'm':
      case 'l':
        doOutline(command, nextX(), nextY());
        break;

      case 'q':
        x = nextX();
        y = nextY();
        doOutline(command, nextX(), nextY(), x, y);
        break;

      case 'b':
        x = nextX();
        y = nextY();
        doOutline(command, nextX(), nextY(), nextX(), nextY(), x, y);
        break;

      case 'z':
        break;

      default:
        break;
    }
  }
}

export var Glyph = /*#__PURE__*/function (_Element) {
  _inherits(Glyph, _Element);

  var _super = _createSuper(Glyph);

  _createClass(Glyph, null, [{
    key: "lookupFontMetric",

    /*
      Static methods used to implement loading and rendering glyphs.
       Below categoryPath can be any metric path under 'glyphs', so stem.up would respolve
      to glyphs.stem.up.shifX, glyphs.stem.up.shiftY, etc.
    */
    value: function lookupFontMetric(_ref) {
      var font = _ref.font,
          category = _ref.category,
          code = _ref.code,
          key = _ref.key,
          defaultValue = _ref.defaultValue;
      var value = font.lookupMetric("glyphs.".concat(category, ".").concat(code, ".").concat(key), null);

      if (value === null) {
        value = font.lookupMetric("glyphs.".concat(category, ".").concat(key), defaultValue);
      }

      return value;
    }
  }, {
    key: "lookupGlyph",
    value: function lookupGlyph(fontStack, code) {
      if (!fontStack) {
        throw Vex.RERR('BAD_FONTSTACK', 'Font stack is misconfigured');
      }

      var glyph;
      var font;

      for (var i = 0; i < fontStack.length; i++) {
        font = fontStack[i];
        glyph = font.getGlyphs()[code];
        if (glyph) break;
      }

      if (!glyph) {
        throw new Vex.RERR('BadGlyph', "Glyph ".concat(code, " does not exist in font."));
      }

      return {
        glyph: glyph,
        font: font
      };
    }
  }, {
    key: "loadMetrics",
    value: function loadMetrics(fontStack, code) {
      var category = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var _Glyph$lookupGlyph = Glyph.lookupGlyph(fontStack, code),
          glyph = _Glyph$lookupGlyph.glyph,
          font = _Glyph$lookupGlyph.font;

      var x_shift = category ? Glyph.lookupFontMetric({
        font: font,
        category: category,
        code: code,
        key: 'shiftX',
        defaultValue: 0
      }) : 0;
      var y_shift = category ? Glyph.lookupFontMetric({
        font: font,
        category: category,
        code: code,
        key: 'shiftY',
        defaultValue: 0
      }) : 0;
      var scale = category ? Glyph.lookupFontMetric({
        font: font,
        category: category,
        code: code,
        key: 'scale',
        defaultValue: 1
      }) : 1;
      var x_min = glyph.x_min;
      var x_max = glyph.x_max;
      var ha = glyph.ha;
      var outline;
      var CACHE = true;

      if (glyph.o) {
        if (CACHE) {
          if (glyph.cached_outline) {
            outline = glyph.cached_outline;
          } else {
            outline = glyph.o.split(' ');
            glyph.cached_outline = outline;
          }
        } else {
          if (glyph.cached_outline) delete glyph.cached_outline;
          outline = glyph.o.split(' ');
        }

        return {
          x_min: x_min,
          x_max: x_max,
          x_shift: x_shift,
          y_shift: y_shift,
          scale: scale,
          ha: ha,
          outline: outline,
          font: font
        };
      } else {
        throw new Vex.RERR('BadGlyph', "Glyph ".concat(code, " has no outline defined."));
      }
    }
    /**
     * A quick and dirty static glyph renderer. Renders glyphs from the default
     * font defined in Vex.Flow.Font.
     *
     * @param {!Object} ctx The canvas context.
     * @param {number} x_pos X coordinate.
     * @param {number} y_pos Y coordinate.
     * @param {number} point The point size to use.
     * @param {string} val The glyph code in font.getGlyphs()
     */

  }, {
    key: "renderGlyph",
    value: function renderGlyph(ctx, x_pos, y_pos, point, val, options) {
      var params = _objectSpread({
        fontStack: Flow.DEFAULT_FONT_STACK,
        category: null
      }, options);

      var metrics = Glyph.loadMetrics(params.fontStack, val, params.category);
      point = params.category ? Glyph.lookupFontMetric({
        font: metrics.font,
        category: params.category,
        code: val,
        key: 'point',
        defaultValue: point
      }) : point;
      var scale = point * 72.0 / (metrics.font.getResolution() * 100.0);
      Glyph.renderOutline(ctx, metrics.outline, scale * metrics.scale, x_pos + metrics.x_shift, y_pos + metrics.y_shift, options);
      return metrics;
    }
  }, {
    key: "renderOutline",
    value: function renderOutline(ctx, outline, scale, x_pos, y_pos, options) {
      ctx.beginPath();
      ctx.moveTo(x_pos, y_pos);
      processOutline(outline, x_pos, y_pos, scale, -scale, {
        m: ctx.moveTo.bind(ctx),
        l: ctx.lineTo.bind(ctx),
        q: ctx.quadraticCurveTo.bind(ctx),
        b: ctx.bezierCurveTo.bind(ctx) // z: ctx.fill.bind(ctx), // ignored

      }, options);
      ctx.fill();
    }
  }, {
    key: "getOutlineBoundingBox",
    value: function getOutlineBoundingBox(outline, scale, x_pos, y_pos) {
      var bboxComp = new BoundingBoxComputation();
      processOutline(outline, x_pos, y_pos, scale, -scale, {
        m: bboxComp.addPoint.bind(bboxComp),
        l: bboxComp.addPoint.bind(bboxComp),
        q: bboxComp.addQuadraticCurve.bind(bboxComp),
        b: bboxComp.addBezierCurve.bind(bboxComp),
        z: bboxComp.noOp.bind(bboxComp)
      });
      return new BoundingBox(bboxComp.x1, bboxComp.y1, bboxComp.width(), bboxComp.height());
    }
    /**
     * @constructor
     */

  }]);

  function Glyph(code, point, options) {
    var _this;

    _classCallCheck(this, Glyph);

    _this = _super.call(this);

    _this.setAttribute('type', 'Glyph');

    _this.code = code;
    _this.point = point;
    _this.options = {
      fontStack: _this.getFontStack(),
      category: null
    };
    _this.metrics = null;
    _this.x_shift = 0;
    _this.y_shift = 0;
    _this.originShift = {
      x: 0,
      y: 0
    };

    if (options) {
      _this.setOptions(options);
    } else {
      _this.reset();
    }

    return _this;
  }

  _createClass(Glyph, [{
    key: "getCode",
    value: function getCode() {
      return this.code;
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = _objectSpread(_objectSpread({}, this.options), options);
      this.reset();
    }
  }, {
    key: "setPoint",
    value: function setPoint(point) {
      this.point = point;
      return this;
    }
  }, {
    key: "setStave",
    value: function setStave(stave) {
      this.stave = stave;
      return this;
    }
  }, {
    key: "setXShift",
    value: function setXShift(x_shift) {
      this.x_shift = x_shift;
      return this;
    }
  }, {
    key: "setYShift",
    value: function setYShift(y_shift) {
      this.y_shift = y_shift;
      return this;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.metrics = Glyph.loadMetrics(this.options.fontStack, this.code, this.options.category); // Override point from metrics file

      this.point = this.options.category ? Glyph.lookupFontMetric({
        category: this.options.category,
        font: this.metrics.font,
        code: this.code,
        key: 'point',
        defaultValue: this.point
      }) : this.point;
      this.scale = this.point * 72 / (this.metrics.font.getResolution() * 100);
      this.bbox = Glyph.getOutlineBoundingBox(this.metrics.outline, this.scale * this.metrics.scale, this.metrics.x_shift, this.metrics.y_shift);
    }
  }, {
    key: "getMetrics",
    value: function getMetrics() {
      if (!this.metrics) {
        throw new Vex.RuntimeError('BadGlyph', "Glyph ".concat(this.code, " is not initialized."));
      }

      return {
        x_min: this.metrics.x_min * this.scale * this.metrics.scale,
        x_max: this.metrics.x_max * this.scale * this.metrics.scale,
        width: this.bbox.getW(),
        height: this.bbox.getH()
      };
    }
  }, {
    key: "setOriginX",
    value: function setOriginX(x) {
      var bbox = this.bbox;
      var originX = Math.abs(bbox.getX() / bbox.getW());
      var xShift = (x - originX) * bbox.getW();
      this.originShift.x = -xShift;
    }
  }, {
    key: "setOriginY",
    value: function setOriginY(y) {
      var bbox = this.bbox;
      var originY = Math.abs(bbox.getY() / bbox.getH());
      var yShift = (y - originY) * bbox.getH();
      this.originShift.y = -yShift;
    }
  }, {
    key: "setOrigin",
    value: function setOrigin(x, y) {
      this.setOriginX(x);
      this.setOriginY(y);
    }
  }, {
    key: "render",
    value: function render(ctx, x, y) {
      if (!this.metrics) {
        throw new Vex.RuntimeError('BadGlyph', "Glyph ".concat(this.code, " is not initialized."));
      }

      var outline = this.metrics.outline;
      var scale = this.scale * this.metrics.scale;
      this.setRendered();
      this.applyStyle(ctx);
      Glyph.renderOutline(ctx, outline, scale, x + this.originShift.x + this.metrics.x_shift, y + this.originShift.y + this.metrics.y_shift);
      this.restoreStyle(ctx);
    }
  }, {
    key: "renderToStave",
    value: function renderToStave(x) {
      this.checkContext();

      if (!this.metrics) {
        throw new Vex.RuntimeError('BadGlyph', "Glyph ".concat(this.code, " is not initialized."));
      }

      if (!this.stave) {
        throw new Vex.RuntimeError('GlyphError', 'No valid stave');
      }

      var outline = this.metrics.outline;
      var scale = this.scale * this.metrics.scale;
      this.setRendered();
      this.applyStyle();
      Glyph.renderOutline(this.context, outline, scale, x + this.x_shift + this.metrics.x_shift, this.stave.getYForGlyphs() + this.y_shift + this.metrics.y_shift);
      this.restoreStyle();
    }
  }]);

  return Glyph;
}(Element);